export enum CurrencyType {
    Undefined = 0,
    CAD = 1,
    CHF = 2,
    EUR = 3,
    GBP = 4,
    NOK = 5,
    SEK = 6,
    USD = 7,
    AUD = 8
}
